import DoctorSignature, { DoctorSignatureFooter, SIGNATURE_FOOTER_SPACE } from "./DoctorSignature";
import {
  Document,
  Page,
  View,
  StyleSheet,
  Image,
  Text,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: { fontSize: 12, color: "#000", paddingBottom: SIGNATURE_FOOTER_SPACE },
  header: {
    paddingHorizontal: 40,
    paddingTop: 20,
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  title: {
    textAlign: "center",
    fontSize: 16,
    fontFamily: "Roboto",
    fontWeight: 700,
    marginBottom: 20,
  },
  chartContainer: {
    margin: "0 auto",
    width: "90%",
    height: 300,
  },
  patientInfo: {
    marginBottom: 15,
    fontSize: 12,
    lineHeight: 1.5,
  },
  footer: {
    marginTop: 20,
    fontSize: 10,
    color: "#666",
    textAlign: "center",
  },
  logo: { width: "100%", height: "15%" },
  watermark: {
    position: "absolute",
    top: "35%",
    left: "15%",
    width: "70%",
    opacity: 0.1,
    zIndex: -10,
  },
  text: {
    marginBottom: 5,
    fontSize: 10,
    fontFamily: "Roboto",
    fontWeight: 400,
    color: "#000",
  },
  textBold: { fontWeight: 700 },
});

const ChartPdf = ({ chartTitle, patientData, chartImage, doctor }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      {/* <Image style={styles.watermark} src="/images/longLogo.png" /> */}
      <Image style={styles.logo} src="/images/headerright.png" />

      <Text style={styles.title}>Reporte de Gráfico: {chartTitle}</Text>
      <View style={styles.header}>
        <View>
          <Text style={styles.text}>
            <Text style={styles.textBold}>Nombre:</Text> {patientData.name}
          </Text>
        </View>
      </View>

      <View style={styles.chartContainer}>
        <Image src={chartImage} style={{ width: "100%", height: "100%" }} />
      </View>
      <DoctorSignatureFooter>
        <DoctorSignature doctor={doctor} />
      </DoctorSignatureFooter>
    </Page>
  </Document>
);

export default ChartPdf;
